import { IClientGridRow } from '@/Interfaces/Client.interface';
import { IControlOption } from '@/Interfaces/ControlOption.interface';
import { Chip, List, ListItem, Popover, styled } from '@mui/material';
import { GridRenderCellParams } from '@mui/x-data-grid';
import { MouseEvent, useCallback, useState } from 'react';

const MultipleChip = styled(Chip)(({ theme }) => ({
  maxHeight: '29px',
  borderRadius: '32px',
  color: theme.palette.text.primary,
  fontWeight: theme.typography.fontWeightBold,
  fontSize: 12,
  overflow: 'text-ellipsis',
  maxWidth: '120px',
}));

const MultipleCell = ({ value }: GridRenderCellParams<IClientGridRow>) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [first, second, ...rest] = value || [];

  const handleClick = useCallback(
    (event: MouseEvent<HTMLElement>) => {
      setAnchorEl(event.currentTarget);
    },
    [setAnchorEl],
  );

  const handleClose = useCallback(() => {
    setAnchorEl(null);
  }, [setAnchorEl]);

  if (!value?.length) {
    return '-';
  }

  return (
    <div className='overflow-hidden flex gap-1'>
      {first && <MultipleChip variant='outlined' label={first?.label} />}
      {second && <MultipleChip variant='outlined' label={second?.label} />}
      {rest.length > 0 && (
        <>
          <MultipleChip variant='outlined' label={`+${rest.length}`} onClick={handleClick} clickable />
          <Popover
            open={Boolean(anchorEl)}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'left',
            }}
          >
            <List disablePadding>
              {rest.map((item: IControlOption) => (
                <ListItem key={item.value} style={{ pointerEvents: 'none', padding: '8px 16px' }}>
                  {item.label}
                </ListItem>
              ))}
            </List>
          </Popover>
        </>
      )}
    </div>
  );
};

export default MultipleCell;
